import { Component, OnInit, OnDestroy, HostListener } from '@angular/core';
import { Form, FormControl, Validators } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { SuccessStories, successStories } from './new-landing-page.constants';

@Component({
  selector: 'app-new-landing-page',
  templateUrl: './new-landing-page.component.html',
  styleUrls: ['./new-landing-page.component.scss'],
})
export class NewLandingPageComponent implements OnInit, OnDestroy {
  mobileNav: boolean = false;
  methodology: string = 'tutoring';
  name: FormControl<string | null> = new FormControl('', [Validators.required]);
  email: FormControl<string | null> = new FormControl('', [
    Validators.email,
    Validators.required,
  ]);
  phone: FormControl<string | null> = new FormControl('', [
    Validators.required,
  ]);

  message: FormControl<string | null> = new FormControl('', [
    Validators.required,
  ]);
  successMessage: string = '';
  errorMessage: string = '';
  error: boolean = false;
  submitClicked: boolean = false;
  carouselIndex: number = 0;
  carouselTimer: number | undefined;
  carouselDirection: string = 'increment';
  // bubbleAnimationTimer: any;
  displayBubble: number | undefined;
  successStories: SuccessStories[] = successStories;

  constructor(private httpClient: HttpClient) {}

  ngOnInit() {
    this.setTimer();
    // this.bubbleAnimationTimer = setInterval(() => {
    //   const randomNumber = this.getRandomNUmber();
    //   this.displayBubble = randomNumber;
    // }, 3000);
    const valueElement: HTMLElement | null = document.getElementById(
      'new-landing-page__winner'
    );
    const coursesElement: HTMLElement | null = document.getElementById(
      'new-landing-page__courses'
    );
    if (valueElement && coursesElement) {
      const valueOffsetTop: number = valueElement['offsetTop'];
      const coursesOffsetTop: number = coursesElement['offsetTop'];
      if (
        window.pageYOffset >= valueOffsetTop &&
        window.pageYOffset <= coursesOffsetTop
      ) {
        let bubbleArray = document.querySelectorAll(
          '.new-landing-page__winner__bubbles__bubble'
        );
        for (let i = 0; i < bubbleArray.length; i++) {
          const bubble = bubbleArray[i];
          // console.log(window.screen.availHeight + window.pageYOffset);
          if (
            !bubble.classList.contains(
              'new-landing-page__winner__bubbles__bubble__animation'
            )
          ) {
            bubble.classList.add(
              'new-landing-page__winner__bubbles__bubble__animation'
            );
          }
        }
      }
    }
  }

  onMobileNav() {
    this.mobileNav = !this.mobileNav;
  }

  // getRandomNUmber(): any {
  //   const randomNumber = Math.floor(Math.random() * (7 - 1) + 1);
  //   if (randomNumber !== this.displayBubble) {
  //     return randomNumber;
  //   } else {
  //     return this.getRandomNUmber();
  //   }
  // }

  setTimer() {
    this.carouselTimer = window.setInterval(() => this.rotateCarousel(), 10000);
  }

  previousSlide = () => {
    if (this.carouselIndex > 0) {
      this.carouselIndex--;
    } else {
      this.carouselIndex = this.successStories.length - 1;
    }
    clearInterval(this.carouselTimer);
    this.setTimer();
  };

  nextSlide = () => {
    if (this.carouselIndex < this.successStories.length - 1) {
      this.carouselIndex++;
    } else {
      this.carouselIndex = 0;
    }
    clearInterval(this.carouselTimer);
    this.setTimer();
  };

  rotateCarousel() {
    if (this.carouselIndex < this.successStories.length - 1) {
      this.carouselIndex++;
    } else {
      this.carouselIndex = 0;
    }
  }

  toggleMethodology(methodology: any) {
    this.methodology = methodology;
  }

  scrollToTop() {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
    console.log('scrolling');
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  }

  scorllToBottom(mobile: any) {
    window.scrollTo({
      top: window.innerHeight,
      behavior: 'smooth',
    });
    if (mobile) {
      this.mobileNav = false;
    }
  }

  scrollTo(id: any, mobile: any) {
    let element = document.getElementById(id);
    if (element) {
      console.log(element);
      let headerOffset = 100;
      let elementPosition = element.getBoundingClientRect().top;
      let offsetPosition = elementPosition + window.pageYOffset - headerOffset;
      console.log(offsetPosition);
      window.focus();
      window.scrollTo({
        top: offsetPosition,
        // behavior: 'smooth',
      });
      document.querySelector(`#${id}`)?.scrollIntoView({ behavior: 'smooth' });
    }
    if (mobile) {
      this.mobileNav = false;
    }
  }

  sendEmail() {
    if (!this.submitClicked) {
      this.submitClicked = true;
      let errorOccurred = false;
      this.successMessage = '';
      this.errorMessage = '';
      if (this.name.invalid || this.name.value?.trim() === '') {
        errorOccurred = true;
      } else if (this.name.invalid || this.name.value?.trim() === '') {
        errorOccurred = true;
      } else if (this.name.invalid || this.name.value?.trim() === '') {
        errorOccurred = true;
      }
      this.error = errorOccurred;
      if (!errorOccurred) {
        this.httpClient
          .post('/api/contact_us', {
            name: this.name.value,
            email: this.email.value,
            phone: this.phone.value,
            message: this.message.value,
          })
          .subscribe(
            (response) => {
              this.submitClicked = false;
              this.successMessage = 'Successfully submitted!';
            },
            (error) => {
              console.log(error);
              this.submitClicked = false;
              this.errorMessage = 'Please try again';
            }
          );
      } else {
        this.submitClicked = false;
      }
    }
  }

  @HostListener('window:scroll', ['$event'])
  onWindowScroll(e: any) {
    let element: any = document.querySelector('#new-landing-page__header');
    if (window.pageYOffset > element.clientHeight / 3) {
      element.classList.add('new-landing-page__header__whiteBackground');
    } else {
      element.classList.remove('new-landing-page__header__whiteBackground');
    }
    let bubbleArray = document.querySelectorAll(
      '.new-landing-page__winner__bubbles__bubble'
    );
    for (let i = 0; i < bubbleArray.length; i++) {
      const bubble: any = bubbleArray[i];
      // console.log(window.screen.availHeight + window.pageYOffset);
      const screenPosition = window.screen.availHeight + window.pageYOffset;
      const bubbleBottom = bubble['offsetTop'] + bubble['offsetHeight'];
      if (
        screenPosition >= bubble['offsetTop'] &&
        screenPosition <= bubbleBottom &&
        !bubble.classList.contains(
          'new-landing-page__winner__bubbles__bubble__animation'
        )
      ) {
        bubble.classList.add(
          'new-landing-page__winner__bubbles__bubble__animation'
        );
      }
    }
  }

  ngOnDestroy() {
    clearInterval(this.carouselTimer);
    // clearInterval(this.bubbleAnimationTimer);
  }
}
